import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import {ListDocentes } from '../models/ListDocentes';

export default class ListaDocentesStore {
    ListaDocentesRegistry = new Map<any, ListDocentes>();
    selectedListaDocentes: ListDocentes | undefined

    editMode = false;
    loading = false;
    loadingInitial = false;
    cargar = 1

    constructor() {
        makeAutoObservable(this)
    }

    get ListaDocentesByCodigo() {
       
        return Array.from(this.ListaDocentesRegistry.values());
    }

    get groupedListaDocentess() {
        return this.ListaDocentesRegistry
    }

    loadListaDocentess = async () => {
        this.loadingInitial = true;
        try {
            this.ListaDocentesRegistry.clear()
            await agent.Docentes.list().then(response => {
                this.ListaDocentesRegistry.set(response.recordsTotal, response);
                
                this.setLoadingInitial(false);
            });
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    loadListaDocentesPagina = async (pagina:number) => {
        this.loadingInitial = true;
        try {
            this.ListaDocentesRegistry.clear()
            await agent.Docentes.paginacion(pagina).then(response => {
                this.ListaDocentesRegistry.set(response.recordsTotal, response);
                
                this.setLoadingInitial(false);
            });
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    loadListaDocentesBusqueda = async (persona:string) => {
        this.loadingInitial = true;
        try {
            this.ListaDocentesRegistry.clear()
            await agent.Docentes.search(persona).then(response => {
                this.ListaDocentesRegistry.set(response.recordsTotal, response);
                //console.log(this.ListaDocentesRegistry)
                this.setLoadingInitial(false);
            });
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    private setCCTMovimiento = (data: ListDocentes) => {
        this.ListaDocentesRegistry.set(data.recordsTotal, data);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }
}